import taxiOfficerEditByTaxiFormValidationService from "./taxi-officer-edit-by-taxi-form-validation.service";
import TaxiOfficerEditByTaxiFormData from "./types/taxi-officer-edit-by-taxi-form-data";
import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import { FormValidationDefinition } from "../../../../../../common/components/form/use-form";

const getDefaultFormData = (): TaxiOfficerEditByTaxiFormData => {
  return {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: phoneNumberInputHelper.getEmptyValue(),
    alternativePhoneNumber: phoneNumberInputHelper.getEmptyValue(),
  };
};

const getValidationDefinition =
  (): FormValidationDefinition<TaxiOfficerEditByTaxiFormData> => {
    return {
      firstName: (values) =>
        taxiOfficerEditByTaxiFormValidationService.validateFirstName(
          values.firstName
        ),
      lastName: (values) =>
        taxiOfficerEditByTaxiFormValidationService.validateLastName(
          values.lastName
        ),
      email: (values) =>
        taxiOfficerEditByTaxiFormValidationService.validateEmail(values.email),
      phoneNumber: (values) =>
        taxiOfficerEditByTaxiFormValidationService.validatePhoneNumber(
          values.phoneNumber
        ),
      alternativePhoneNumber: (values) =>
        taxiOfficerEditByTaxiFormValidationService.validateAlternativePhoneNumber(
          values.alternativePhoneNumber
        ),
    };
  };

const taxiOfficerEditByTaxiFormHelper = {
  getDefaultFormData,
  getValidationDefinition,
};

export default taxiOfficerEditByTaxiFormHelper;
